import { render } from "./AcreditacionFinalizada.vue?vue&type=template&id=5818b964&ts=true"
import script from "./AcreditacionFinalizada.vue?vue&type=script&lang=ts"
export * from "./AcreditacionFinalizada.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__